type IconProps = {
  size?: number;
  className?: string;
  color?: string;
};

/** Send control — purple rounded square with up arrow (Figma Arrow.svg). */
export function SendArrowIcon({ size = 40, className }: Omit<IconProps, 'color'>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill="var(--color-composer-send-bg, var(--color-primary))"
      />
      <path
        d="M20 29.3333V10.6667M27 17.6667L20 10.6667L13 17.6667"
        stroke="var(--color-primary-foreground)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronDownIcon({ size = 10, className, color = 'currentColor' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="none" className={className} aria-hidden>
      <path
        d="M2.5 3.75 5 6.25 7.5 3.75"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** @deprecated Use `PinIcon` with `filled={false}` from `@/components/icons`. */
export { PinIcon as PinOutlineIcon } from './PinIcon';

/** @deprecated Use `DeviceControllerIcon` from `@/components/icons`. */
export { DeviceControllerIcon as DoorControllerIcon } from './DeviceControllerIcon';

/** @deprecated Use `VideoControllerIcon` from `@/components/icons`. */
export { VideoControllerIcon as VideoRecorderIcon } from './VideoControllerIcon';
